






import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import $ from 'jquery';
import Postmate from 'postmate';
import BaseView from '../BaseView';
import Common from '../helper/Common';

@Component({})
export default class CriteriaEditor extends BaseView {

    @Prop(Number) public AudienceDetailID!: number;
    @Prop(Number) public ClientID!: number;
    @Prop({ default: false }) public disabled!: boolean;

    public isLoaded: boolean = false;
    public isCriteriaChanged: boolean = false;
    private postmate!: any;
    private criteria!: object;

    @Emit()
    public onCriteriaChange() {
        return String;
    }

    @Emit()
    public onReady() {
        return;
    }

    @Emit()
    public isModified() {
        return Boolean;
    }

    public getValue(callback: (data: object) => {} | undefined) {
        // Send a getCriteria request event to the child iframe
        this.postmate.then( (child) => {
            child
                // Step 1: Is the Criteria Model Valid?
                .get('criteriaEditor_isValid')
                .then((isValid) => new Promise((resolve, reject) => {
                    // Note: the criteriaEditor.js will raise showAlerts for isValid==false
                    // So we don't have to handle anything here if we aren't valid
                    if (isValid) {
                        // Only move on to the next Promise if we are valid
                        resolve(isValid);
                    } else {
                        reject();
                    }
                }))
                // Step 2: Get the valid Criteria
                .then(() => {
                    child
                        .get('criteriaEditor_getCriteria')
                        .then((data) => {
                            if (!this.critieraAreEqual(this.criteria, data)) {
                                this.$emit('on-criteria-change', data);
                                this.criteria = data;
                            }

                            if (callback) {
                                callback.call(null, data);
                            }
                        });
                });
        });
    }

    public setValue(data: object) {
        this.criteria = data;

        this.postmate.then((child) => {
            child.call('criteriaEditor_setCriteria', data);
        });
    }

    public repositionFiltersList(data: any) {
        this.postmate.then((child) => {
            child.call('criteriaEditor_repositionFiltersList', data);
        });
    }

    public checkModify() {
        const self = this;
        this.postmate.then((child) => {
            child
                .get('criteriaEditor_getCriteria')
                .then((data) => {
                    // ignore propertyPool since it can be checked if it was changed in the details editor.
                    data.propertyPool = [];
                    const criteria: any = self.criteria;
                    criteria.propertyPool = [];
                    this.$emit('is-criteria-modify', !(this.critieraAreEqual(data, criteria)));
                });
        });
    }

    private stringToHash(str) {
        let hash: number = 0;
        if (str.length === 0) {
            return hash;
        }
        for (let i = 0; i < str.length; i++) {
            hash += str.charCodeAt(i);
        }
        return hash;
    }

    private critieraAreEqual(a: object, b: object): boolean {
        // Set to empty object is undefined / null
        a = (a) ? a : {};
        b = (b) ? b : {};
        const aHash = this.stringToHash(JSON.stringify(a));
        const bHash = this.stringToHash(JSON.stringify(b));
        return (aHash === bHash);
    }

    private mounted() {
        const criteriaVue = this;

        // Create the Postmate iframe
        this.postmate = new Postmate({
            container: $('div.criteriaContainer')[0],
            url: '/legacy/criteria/editor.html'
        });

        // Wire up child frame emit events
        this.postmate.then((child) => {
            // Respond to content height changes
            child.on('criteriaEditor_heightChanged', (newHeight) => {
                this.updateFrameHeight(newHeight);
            });

            // Start the Editor
            child.on('criteriaEditor_loaded', () => {
                // this.showLoader();
                Common.blockElement('criteriaPlaceholder');
                child.call('criteriaEditor_start', {
                    client_id: this.ClientID,
                    disabled: this.disabled,
                    audience_details_id: criteriaVue.AudienceDetailID,
                    eInsightDomain: encodeURIComponent(window.App.$appSettings.eInsightUri),
                    eInsightUserEmail: window.eInsightUserEmail
                });
            });

            child.on('criteriaEditor_ready', () => {
                // The criteria editor can load by Audience ID so we should ask what the current criteria
                // value is once it has loaded to make sure we are synchronized with the child frame
                this.postmate.then((child) => {
                    // this.showLoader();
                    Common.blockElement('criteriaPlaceholder');
                    child
                        .get('criteriaEditor_getCriteria')
                        .then((data) => {
                            console.log('criteriaEditor_getCriteria => data', data);
                            this.criteria = data;

                            this.isLoaded = true;
                            // Wait to emit on-ready until we have synchronized our value at least once
                            this.$emit('on-ready');

                            // this.hideLoader();
                            Common.unblockElement('criteriaPlaceholder');
                        });

                });
            });

            child.on('showAlert', (options: any) => {
                switch (options.type) {
                    case 'success':
                        this.successToastPopup(options.message, options.headline, options.isDismissible);
                        break;
                    case 'danger':
                        this.dangerToastPopup(options.message, options.headline, options.isDismissible);
                        break;
                    case 'warning':
                    default:
                        this.warningToastPopup(options.message, options.headline, options.isDismissible);
                        break;
                }
            });

            child.on('criteriaEditor_changed', (newModel: any) => {
                this.isCriteriaChanged = true;
                this.criteria = newModel;
                this.$emit('on-criteria-change', this.criteria);
            });
        });
    }

    private beforeDestroy() {
        // Clean up our iframe events
        this.postmate.then((child) => {
            child.destroy();
        });
    }

    private updateFrameHeight(newHeight) {
        this.postmate.then( (child) => {
            const currentHeight = child.frame.getAttribute('height') || 0;
            if (newHeight.toString() !== currentHeight.toString()) {
                child.frame.setAttribute('height', newHeight);
            }
        });
    }
}
